import Button from "@commons/Button";
import ComboBox from "@commons/Input/ComboBox";
import Text from "@commons/Typography/Text";
import SearchIcon from "@mui/icons-material/Search";
import { searchIndividuals } from "@services/individuals/search";
import { searchTaxonomic } from "@services/taxonomicGroups/search";
import type { ComboBoxOption } from "@typings/components/comboBox";
import type { Individual } from "@typings/entities/individuals";

import type { MapFilters } from "@typings/entities/individuals/map";
import type { TaxonomicGroup } from "@typings/entities/taxonomicGroup";
import { useState } from "react";

type MapFilterProps = {
  onChange: (field: keyof MapFilters, value: string) => void;
  onApply: () => void;
};

function MapFilter({ onChange, onApply }: MapFilterProps) {
  const [selectedSpecies, setSelectedSpecies] =
    useState<ComboBoxOption<TaxonomicGroup> | null>(null);
  const [selectedIndividual, setSelectedIndividual] =
    useState<ComboBoxOption<Individual> | null>(null);

  return (
    <div>
      <div className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 xl:grid-cols-5 2xl:grid-cols-7 gap-4 w-full max-w-xl sm:max-w-none">
        <ComboBox<TaxonomicGroup>
          value={selectedSpecies}
          onChange={(e) => {
            setSelectedSpecies(e);
            onChange("taxonomicGroupId", e?.value ?? "");
          }}
          searchService={searchTaxonomic}
          label="Espécie"
          minSearchLength={0}
          debounceTime={300}
        />
        <ComboBox<Individual>
          value={selectedIndividual}
          onChange={(e) => {
            setSelectedIndividual(e);
            onChange("individual", e?.item?.marking ?? "");
          }}
          searchService={searchIndividuals}
          label="Marcação"
          minSearchLength={0}
          debounceTime={300}
        />

        <div className="flex items-end">
          <Button
            startIcon={<SearchIcon />}
            customVariant="primary"
            size="full"
            onClick={onApply}
          >
            <Text>Filtrar</Text>
          </Button>
        </div>
      </div>
    </div>
  );
}

export default MapFilter;
